module.exports = __webpack_public_path__ + "img/progress_5.6710814b.png";